
import { useData8 } from "@/services/data8";
import { defineComponent } from "vue";
import GenericSearch from "@/components/search/GenericSearch.vue";
import { storeToRefs } from "pinia";

export default defineComponent({
  components: { GenericSearch },
  setup() {
    const store = useData8();
    const { options } = storeToRefs(store);
    const { selectAddress: select, loadOptions: search } = store;
    return {
      options,
      search,
      select,
    };
  },
});
